<template>
  <div class="c-app">
    <TheSidebar :role="role"/>
    <CWrapper>
      <TheHeader :name="name" :userDetail="userDetail" v-if="!printPDF"/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition mode="out-in" name="fade">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import {mapGetters} from "vuex"

export default {
  name: 'TheContainer',
  data() {
    return {
      userInformation: {},
      name: "",
      role: "",
      userDetail: {
        username: "",
        email: "",
        tel: ""
      }
    }
  },
  components: {
    TheSidebar,
    TheHeader,
    TheFooter
  },
  mounted() {
    this.$store.dispatch("profile/onFetchUserInformation")
  },
  computed: {
    ...mapGetters({
      userInfo: "profile/userInformation",
      printPDF: "printPDF"
    })
  },
  watch: {
    userInfo(value) {
      this.userInformation = value
      this.name = value.firstName + " " + value.lastName
      this.role = value.role
      this.userDetail = {
        username: value.username,
        email: value.email,
        tel: value.tel
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
